<template>
    <div class="w-full inline-flex flex-col items-center" style="min-height: 300px;">
        <h2 class="text-2xl mb-2 text-gray-800 dark:text-white">
            Les Prochains
            <span v-if="$store.state.selected.ligne === 'A'">Trams</span>
            <span v-else>Bus</span> :
        </h2>
        <placeholder v-if="$store.state.times.length === 0"></placeholder>
        <section v-else role="list">
            <div v-for="(i, k) in $store.state.times" :key="k"
                :aria-label="i.replace('min', 'minutes').replace('h', 'heures')"
                class="text-3xl leading-relaxed text-gray-900 dark:text-white">
                <div v-if='$store.state.realtimeResponse.new_times[k] && $store.state.realtimeResponse.new_times[k].is_canceled'
                    class="relative">
                    <div class="text-xs bg-red-500 text-slate-50 dark:text-slate-100 font-medium px-2 py-0.5 rounded-md absolute -right-8 bottom-8"
                        style="transform: rotate(25deg);">
                        annulé
                    </div>
                    <div class="text-red-500">{{ i }}</div>
                </div>

                <div v-else-if='$store.state.realtimeResponse.new_times[k] && $store.state.realtimeResponse.new_times[k].is_delayed'
                    class="relative">
                    <div class="text-xs bg-orange-500 text-slate-50 dark:text-slate-100 font-medium px-2 py-0.5 rounded-md absolute -right-8 bottom-8"
                        style="transform: rotate(25deg);">retard</div>
                    <div class="text-orange-500">{{ i }}</div>
                </div>

                <div v-else>{{ i }}</div>
            </div>
        </section>
    </div>
</template>

<script>
import placeholder from "./placeholder";

export default {
    name: "Next",
    components: {
        placeholder
    }
};
</script>
